/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  MetadataGetOptionalParams,
  MetadataGetResponse,
  MetadataPostOptionalParams,
  MetadataPostResponse
} from "../models/index.js";

/** Interface representing a Metadata. */
export interface Metadata {
  /**
   * Retrieve the metadata information for the workspace, including its schema, functions, workspace
   * info, categories etc.
   * @param workspaceId Primary Workspace ID of the query. This is the Workspace ID from the Properties
   *                    blade in the Azure portal.
   * @param options The options parameters.
   */
  get(
    workspaceId: string,
    options?: MetadataGetOptionalParams
  ): Promise<MetadataGetResponse>;
  /**
   * Retrieve the metadata information for the workspace, including its schema, functions, workspace
   * info, categories etc.
   * @param workspaceId Primary Workspace ID of the query. This is the Workspace ID from the Properties
   *                    blade in the Azure portal.
   * @param options The options parameters.
   */
  post(
    workspaceId: string,
    options?: MetadataPostOptionalParams
  ): Promise<MetadataPostResponse>;
}
